<template lang="pug">
.caseTitleText
  .title-box
    Form(:model="question")
      .title-stem
        FormItem
          Input.input1(type='text',placeholder='标题',v-model='question.context')
        iDelModel.ide(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
        FormItem
          Input.input2(type='textarea',placeholder='说明',v-model='question.content',:rows="4")
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
export default {
  components: {
    iDelModel
  },
  data() {
    return {
      question: {
        context: "",
        content: ""
      }
    };
  },
  methods: {
    // 删除
    delModel() {
      this.$emit("delModel");
    }
  }
};
</script>
<style lang="stylus">
.caseTitleText
  .title-box
    padding 24px
    width 100%
    margin 0 auto
    .title-stem
      position relative
      .input1
        width 80%
        float left
      .ivu-form-item-content
        // margin-right 300px
      .btns
        position absolute
        top -5px
        right 0px
        .ivu-icon
          color #3A76D2FF
          font-size 22px
          top 0
          margin-right 12px
          background #F2F5FAFF
          width 24px
          height 24px
          border-radius 4px
          text-align center
          line-height @height
          &:hover
            cursor pointer
</style>
